import { createThunk, model, Model } from 'mst-collection';
import { getRoot, types } from 'mobx-state-tree';

import { Api, QuestStatusEnum } from '@api';
import { QuestTopicListModel } from './QuestTopicListModel';
import { useRoot } from '../useRoot';
import type { RootModelType } from '../RootModel';
import type { ICurrentUser } from '../Viewer/UserModel';
import type { UserSettings } from '../Viewer/UserSettingsModel';

export class Questionnaire extends Model({
  list: types.optional(QuestTopicListModel, {}),
}) {
  get canBeSaved() {
    return this.list.selectedTopicIds.length > 0;
  }

  private get _userSettings(): UserSettings {
    return (
      getRoot<RootModelType>(this).viewer.currentUser as ICurrentUser
    ).settings;
  }

  save = createThunk(() => {
    return async function save(this: Questionnaire) {
      await Api.Profile.questSelect({
        questStatus: QuestStatusEnum.Done,
        topicIds: this.list.selectedTopicIds,
      });
      this._userSettings.setQuestStatus(QuestStatusEnum.Done);
    };
  });

  skipAndSave = createThunk(() => {
    return async function skipAndSave(this: Questionnaire) {
      await Api.Profile.questSelect({
        questStatus: QuestStatusEnum.Skipped,
        topicIds: this.list.selectedTopicIds,
      });
      this._userSettings.setQuestStatus(QuestStatusEnum.Skipped);
    };
  });

  skipAndNeverAsk = createThunk(() => {
    return async function skipAndNeverAsk(this: Questionnaire) {
      await Api.Profile.questSelect({
        questStatus: QuestStatusEnum.NeverAsk,
        topicIds: [],
      });
      this._userSettings.setQuestStatus(QuestStatusEnum.NeverAsk);
    };
  });
}

export const QuestionnaireModel = model(Questionnaire);

export function useQuestionnaireModel() {
  const root = useRoot();

  return root.questionnaire;
}
